/**
 * French FAQ copy. Mirrors the Dutch master in ../faq-data.ts: same
 * three categories, same eleven questions, same order. Every shipping
 * and returns number is interpolated from the live policy `p`, never
 * written into the copy, and the shipping answers name the country the
 * terms apply to (the policy is resolved for NL and BE only).
 */

import type { FAQPolicyValues } from "../faq-data.ts";
import type { FaqBuilder } from "./index.ts";

const buildFaqsFr: FaqBuilder = (p: FAQPolicyValues, fmt) => {
  const secondaryLine =
    p.secondaryCountryName && p.secondaryFreeAbove
      ? ` Vers la Belgique, la livraison est gratuite à partir de €${fmt.eur(p.secondaryFreeAbove)}.`
      : "";
  return [
    {
      category: "Produits & allergies",
      items: [
        {
          q: "J'ai une allergie, vos produits sont-ils adaptés ?",
          a: "Dans presque tous les cas, nos produits sont adaptés. Envoyez-nous un e-mail en précisant votre allergie et nous vous conseillerons personnellement sur les produits sûrs pour vous. Vous pouvez également commander d'abord un échantillon pour tester le produit sur une petite zone de peau.",
        },
        {
          q: "Que signifie hypoallergénique ?",
          a: "Hypoallergénique signifie que le risque de réaction allergique est extrêmement faible. Tous les produits Unity Cosmetics sont hypoallergéniques. Nous choisissons délibérément des ingrédients qui présentent le moins de risque possible d'irritation.",
        },
        {
          q: "Comment puis-je tester si un produit me convient ?",
          a: "Nous vous conseillons d'essayer d'abord le produit sur une petite zone à l'intérieur du coude. En cas d'hypersensibilité ou de réaction allergique, celle-ci se manifeste généralement dans les 24 heures sous forme de démangeaisons, de légères rougeurs et parfois de petits boutons. Des échantillons sont disponibles pour la plupart des produits.",
        },
        {
          q: "Vos produits sont-ils vegan ?",
          a: "Une grande partie de notre gamme est vegan. Sur la page produit, les classifications indiquent si le produit est vegan. Tous les produits sont sans cruauté.",
        },
        {
          q: "Vos produits contiennent-ils du gluten ?",
          a: "Tous nos produits sont sans gluten. Cette information figure également dans les classifications sur la page produit.",
        },
      ],
    },
    {
      category: "Commander & payer",
      items: [
        {
          q: "Quels moyens de paiement acceptez-vous ?",
          a: "Nous acceptons iDEAL, Visa, Mastercard, PayPal, Klarna (paiement différé), Bancontact et le virement SEPA.",
        },
        {
          q: "Quand vais-je recevoir ma commande ?",
          a: `Les commandes sont livrées sous ${fmt.deliveryWindow} via ${p.carrier} avec suivi Track & Trace. Vous recevrez un e-mail de confirmation avec le code de suivi dès que votre colis sera expédié.`,
        },
        {
          q: "La livraison est-elle gratuite ?",
          a: `Oui, pour les commandes livrées aux Pays-Bas, la livraison est gratuite à partir de €${fmt.eur(p.primaryFreeAbove)}.${secondaryLine}`,
        },
        {
          q: "Puis-je aussi commander des échantillons ?",
          a: "Oui, des échantillons sont disponibles pour la plupart des produits. Vous pouvez ainsi tester le produit sur votre peau avant d'acheter la taille complète.",
        },
      ],
    },
    {
      category: "Retours",
      items: [
        {
          q: "Puis-je retourner un produit ?",
          a: `Vous disposez de ${p.returnWindowDays} jours de réflexion après réception de votre commande. Les produits doivent être retournés non ouverts et dans leur emballage d'origine. Les frais de retour sont à votre charge (environ €${fmt.eur(p.returnCost)}).`,
        },
        {
          q: "Que faire en cas de réaction allergique ?",
          a: "Contactez-nous immédiatement. Bien que le risque soit extrêmement faible avec nos produits, nous prenons chaque réaction au sérieux. Nous vous aiderons à trouver une solution adaptée.",
        },
      ],
    },
  ];
};

export default buildFaqsFr;
